<template>
    <div>
        <div class="container">
            <div class='text-center row justify-content-md-center'>
                <loader v-show="loader" message="Enregistrement de vos informations en cours..."></loader>
            </div>
            <div v-show="!loader" class="row justify-content-md-center" id="steps">
                <div class="col col-lg-5" id="step2">
                    <span class="circle">1</span>
                    <div class='card panel_form'>
                        <div class="card-body">
                            <h3 class='text-center panel-title title_form'>Vos informations</h3>
                            <b-row>
                                <b-col sm="5">
                                    <label for="civilite">Civilité</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-select v-model="civilite" name="civilite" id="civilite" @change="form_checker_1_3"><option value="Madame">Madame</option><option value="Monsieur">Monsieur</option></b-form-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5">
                                    <label for="prenom">Votre prénom</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input v-model="prenom" type="text" name="prenom" id="prenom" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5">
                                    <label for="nom">Votre nom</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input v-model="nom" type="text" name="nom" id="nom" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5">
                                    <label for="telephone">Téléphone</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input type="tel" v-mask="'0#.##.##.##.##'" id="telephone" v-model="telephone" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5">
                                    <label for="email">E-mail</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input v-model="email" id="email" type="text" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5">
                                    <label for="residence">Lieu de résidence</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-select v-model="residence" name="residence" id="residence" @change="form_checker_1_3">
                                        <option value="france">France</option>
                                        <option value="domtom">Dom-Tom</option>
                                        <option value="horsunioneuropeenne">Autre pays</option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            <b-row class="d-none">
                                <b-col sm="5">
                                    <label for="adresse">Votre adresse</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input v-model="adresse"  type="text" name="adresse" id="adresse" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5">
                                    <label for="codepostal">Votre code postal</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input v-model="codepostal" type="text" name="codepostal" id="codepostal" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row  class="d-none">
                                <b-col sm="5">
                                    <label for="ville">Votre ville</label>
                                </b-col>
                                <b-col sm="7">
                                    <b-form-input v-model="ville" type="text" name="ville" id="ville" @input="form_checker_1_3"></b-form-input>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
                <!--!source-->
                <div  class="col col-lg-5" v-if="showcvblock">
                        <span class="circle">2</span>
                        <div class='card panel_form'>
                            <div class="card-body">
                                
                                <form class='form-horizontal' id='form_sourcing'>
                                    <h3 class='text-center panel-title title_form'>Votre CV</h3>
                                    
                                    <div id='wrapper_form' class='row'>
                                        <div class=' mx-auto'>
                                            <div v-show='!loader' id='cv' class='text-center'>
                                                <span id='error_upload' v-show='error_upload' v-html='error_upload'></span>
                                                <div  class="d-none">
                                                    <p><label>Votre poste actuel</label></p>
                                                    <p><b-form-textarea v-model="poste"  name="poste" id="poste" @input="form_checker_2_3" ></b-form-textarea></p>
                                                    <p><label>Vos expériences significatives</label></p>
                                                    <p><b-form-textarea v-model="xp"  name="xp" id="xp" @input="form_checker_2_3" ></b-form-textarea></p>
                                                </div>
                                                <div class='input-file-container' v-show="!source">
                                                    <form :action="access_point + '/prospect/formsourcing/uploadcv'" method='post' enctype='multipart/form-data' id='form_ie'>
                                                        <input type='hidden' name='email' id='email' :value='email' />
                                                        <input class='input-file' type='file' id='file_cv' name='resume' v-on:change='infoFile' />
                                                        <label for='file_cv' id='label_file_cv' class='input-file-trigger' tabindex='0' v-on:click='focusFile'><font-awesome-icon icon="file-upload" /> Chargez votre CV</label>
                                                    </form>
                                                </div>
                                                <p class="text-center"><small>(facultatif)</small></p>
                                                <p class='file-return' v-show='info_file'>{{info_file}}&nbsp;</p>
                                            </div>
                                            
                                        
                                        </div>
                                    </div>
                                </form>
                                
                            </div>
                        </div>
                    </div>
            </div>
            
            <transition name="fade">
                <div v-show="!loader" class="row justify-content-md-center">
                    <div class="col col-lg-5">
                        <div class='card panel_form_submit'>
                            <div class="card-body">
                                <div class='text-center'>
                                    <span id='bt_envoyer'  class='btn' v-on:click='uploadCandidat'><font-awesome-icon icon="calendar-check" /> <span>Enregistrer mes informations</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <b-modal id="modal-1" title="Oups !" ref="champsrequis" ok-only size="sm">
            <p class="my-4">Vous avez omis certains champs !</p>
        </b-modal>
        <b-modal id="modal-2" title="Oups !" ref="error" ok-only size="sm">
            <p class="my-4">Une erreur est survenue, veuillez réessayer ultérieurement. Si le problème persiste vous pouvez envoyer vos informations par mail sur recrutement@rivalis.fr</p>
        </b-modal>

        
    </div>
</template>

<script>
export default {
    props: ["source"],
    methods: {
        form_checker_1_3 () {
            if (
						this.email != '' &&
						this.civilite != '' &&
						this.nom != '' &&
						this.prenom != '' &&
						this.telephone != '' &&
						this.residence != '' &&
						this.ville != '' &&
						this.adresse != '' &&
						this.codepostal != ''
            ) {
                this.check_1_3 = true
            } else {
                this.check_1_3 = false
            }
        },
        form_checker_2_3 () {
            if (
                this.xp != '' &&
                this.poste != ''
            ) {
                this.check_2_3 = true
            } else {
                this.check_2_3 = false
            }
        },
        form_checker_3_3 () {
            if (
                this.metier_marche_porteur !== false &&
                this.impact_direct_economie !== false &&
                this.liberte_pro !== false &&
                this.meilleur_qualite_pro !== false &&
                this.gagner_plus !== false &&
                this.sensible_reussite_autre !== false
            ) {
                this.check_3_3 = true
            } else {
                this.check_3_3 = false
            }
        },
        noCV () {
            this.withcv = false
        },
        withCV () {
            this.withcv = true
        },
        emailIsValid (email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        /*validate_form () {
            this.emailIsValid(this.email)
        },*/
        focusFile () {
            document.querySelector('.input-file').focus()
            return false
        },
        infoFile (event) {
            if (this.detectIE() === false) {
                this.info_file = event.target.files[0]['name']
            } 
            this.bt_envoyer_info = true
        },
        uploadCandidat () {
            var instance = this
            var ie = this.detectIE()
            this.bt_envoyer_info = false
            if (ie === false || (ie && ie >= 10)) {
                var validate = this.validateForm()
                if (validate === 0) {
                    this.error_upload = ''
                    this.loader = true
                    //this.$set(this, "loader", true)
                    
                    var payload = new FormData()
                    this.nom = this.nom.toUpperCase()
                    this.prenom = this.prenom.charAt(0).toUpperCase() + this.prenom.slice(1)
                    if (this.showcvblock && typeof this.source_d === "undefined") {
                        var file = document.getElementById('file_cv').files[0]
                        payload.append('resume', file)
                    }
                    payload.append('gender', this.civilite)
                    payload.append('email', this.email)
                    payload.append('nom', this.nom)
                    payload.append('prenom', this.prenom)
                    payload.append('telephone', this.telephone)
                    payload.append('source', this.source_d)

                    for (const [key, value] of Object.entries(this.$route.query)) {
                        payload.append('qs_'+key, value)
                    }
                    

                    payload.append('zapomp', 54896)
                    payload.append('residence', this.residence)
                    payload.append('codepostal', this.codepostal)
                    //payload.append('adresse', this.adresse)
                    //payload.append('ville', this.ville)

                    var xhr = new XMLHttpRequest()
                    xhr.open(
                        'POST',
                        this.access_point + '/prospect/formsourcing/uploadcv',
                        true
                    )
                    xhr.onreadystatechange = function () {
                        if (this.readyState === XMLHttpRequest.DONE) {
                        if (
                            this.status === 408 ||
                            this.status === 500 ||
                            this.status === 503 ||
                            this.status === 504 ||
                            this.status === 444 ||
                            this.status === 520 ||
                            this.status === 521 ||
                            this.status === 522
                        ) {
                            instance.error_upload = 'Erreur de connexion'
                            this.bt_envoyer_info = true
                            //instance.loader = false
                            instance.$set(instance, "loader", false)
                        }
                        if (this.status === 200) {
                            var response = JSON.parse(xhr.responseText)
                            if (response["success"] == true) {
                                response["email"] = instance.email
                                response["initial_email"] = instance.initial_email
                                response["nom"] = instance.nom
                                response["prenom"] = instance.prenom
                                response["telephone"] = instance.telephone
                                response["civilite"] = instance.civilite
                                response["residence"] = instance.residence
                                instance.$emit('updateuploadcv', response)
                            } else {
                                this.$refs['error'].show()
                            }
                            
                        }
                        }
                    }
                    xhr.send(payload)
                } else {
                    this.$refs['champsrequis'].show()
                    this.bt_envoyer_info = true
                }
            } else {
                // instance.error_upload = 'Votre navigateur n\'est plus supporté par notre page web, vous pouvez nous transmettre votre CV à jour à cette adresse : recrutement@rivalis.fr. Cliquer sur ce lien pour passer cette étape et définir votre rendez-vous : <a href='https://calendly.com/' + instance.calendly + '?email=' + instance.$route.params.email + ''>cliquez-ici</a>.'
                //instance.loader = false
                instance.$set(instance, "loader", false)
                document.getElementById('form_ie').submit()
            }
            return false
        },
        scrollMeTo (refName) {
            var element = document.getElementById(refName)
            var top = element.offsetTop + 600
            window.scrollTo(0, top)
        },
        validateForm () {
            var err = 0
            if (this.civilite == "") {
                err++
                document.getElementById("civilite").classList.add("error")
            } else {
                document.getElementById("civilite").classList.remove("error")
            }
            if (this.email == "") {
                err++
                document.getElementById("email").classList.add("error")
            } else {
                document.getElementById("email").classList.remove("error")
            }
            if (this.nom == "") {
                err++
                document.getElementById("nom").classList.add("error")
            } else {
                document.getElementById("nom").classList.remove("error")
            }
            if (this.prenom == "") {
                err++
                document.getElementById("prenom").classList.add("error")
            } else {
                document.getElementById("prenom").classList.remove("error")
            }
            if (this.telephone == "") {
                err++
                document.getElementById("telephone").classList.add("error")
            } else {
                document.getElementById("telephone").classList.remove("error")
            }

            /*if (this.adresse == "") {
                err++
                document.getElementById("adresse").classList.add("error")
            } else {
                document.getElementById("adresse").classList.remove("error")
            }

            if (this.ville == "") {
                err++
                document.getElementById("ville").classList.add("error")
            } else {
                document.getElementById("ville").classList.remove("error")
            }*/

            if (this.codepostal == "") {
                err++
                document.getElementById("codepostal").classList.add("error")
            } else {
                document.getElementById("codepostal").classList.remove("error")
            }

            
            if (this.residence == "") {
                err++
                document.getElementById("residence").classList.add("error")
            } else {
                document.getElementById("residence").classList.remove("error")
            }
           

            
            
            if (this.email === 'recrutement') {
                err++
                this.error_upload =
                'Vous avez omis de renseigner votre email.'
            }
            if (this.source === false) {
                var file = document.getElementById('file_cv').files[0]
                if (typeof file === 'undefined') {
                    err++
                    this.error_upload =
                    'Vous avez omis de cliquer sur parcourir et de sélectionner votre CV à jour.'
                }
                var types = [
                    'image/gif',
                    'image/png',
                    'image/jpeg',
                    'application/msword',
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    ''
                ]

                if (typeof file === 'undefined' || types.indexOf(file['type']) === -1) {
                    err++
                    this.error_upload =
                    'Fichier non autorisé ou non déposé'
                }
            }
            return err
        },
        getQueryStringValue (key) {
            return decodeURIComponent(
                window.location.search.replace(
                new RegExp(
                    '^(?:.*[&\\?]' +
                    encodeURIComponent(key).replace(/[.+*]/g, '\\$&') +
                    '(?:\\=([^&]*))?)?.*$',
                    'i'
                ),
                '$1'
                )
            )
        },
        detectIE () {
            var ua = window.navigator.userAgent
            var msie = ua.indexOf('MSIE ')
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
            }
            var trident = ua.indexOf('Trident/')
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:')
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
            }
            var edge = ua.indexOf('Edge/')
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
            }
            // other browser
            return false
        }
    },
    mounted () {
        if (this.$route.hasOwnProperty("origine_du_contact_jobboard"))
            this.origine_du_contact_jobboard = this.$route.origine_du_contact_jobboard
        if (this.$route.hasOwnProperty("recherche_effectuee_sur_jobboard"))
            this.recherche_effectuee_sur_jobboard = this.$route.recherche_effectuee_sur_jobboard
        if (this.$route.hasOwnProperty("cat_profil_jobboard"))
            this.cat_profil_jobboard = this.$route.cat_profil_jobboard
        if (this.$route.hasOwnProperty("source_interface"))
            this.source_interface = this.$route.source_interface
        if (this.$route.hasOwnProperty("agent_rdv"))
            this.agent_rdv = this.$route.agent_rdv
        
        if (this.showcvblock && typeof this.source_d === "undefined") {
            if (this.detectIE() === false) {
                document.getElementById('cv').setAttribute('class', 'text-center js')
            } else {
                console.log("IE")
                document.getElementById('label_file_cv').style.display = 'none'
            }
        }

        this.withcv = typeof this.source_d === "undefined" ? true : false
        this.bt_envoyer_info = typeof this.source_d === "undefined" ? false : true
				const urlParams = new URLSearchParams(window.location.search)
				this.email=urlParams.get("email")??''
				this.civilite=urlParams.get("civilite")??''
				this.nom=urlParams.get("nom")??''
				this.prenom=urlParams.get("prenom")??''
				this.telephone=urlParams.get("telephone")??''
				this.residence =urlParams.get("residence")??''
				this.ville=urlParams.get("ville")??''
				this.adresse=urlParams.get("adresse")??''
				this.codepostal=urlParams.get("codepostal")??''
    },
    data () {
        return {
            showcvblock: false,
            withcv: true,
            access_point: "https://recrutement.rivalis.cognix-systems.net",
            loader: false,
            error_upload: false,
            info_file: false,
            bt_envoyer_info: false,
            source_d : this.source,
            email: (this.$route.params.email && this.$route.params.email != "bW9uQGVtYWlsLmNvbQ==") ? decodeURIComponent(escape(window.atob( this.$route.params.email ))) : "",
            civilite: '',
            nom: '',
            prenom: '',
            telephone: '',
            residence: '',
            xp: '',
            ville: '',
            adresse: '',
            codepostal: '',
            poste: '',
            origine_du_contact_jobboard: false,
            recherche_effectuee_sur_jobboard: false,
            cat_profil_jobboard: false,
            source_interface: false,
            agent_rdv: false,
            validate_form: false,
            validate_psy: false,
            metier_marche_porteur: false,
            impact_direct_economie: false,
            liberte_pro: false,
            meilleur_qualite_pro: false,
            gagner_plus: false,
            sensible_reussite_autre: false,
            check_1_3: false,
            check_2_3: false,
            check_3_3: false,
            initial_email: (this.$route.params.email) ?decodeURIComponent(escape(window.atob( this.$route.params.email ))) : ""
        }
    }
}
</script>

<style lang="less">

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


#withcv{
    margin-top:15px;
    span{
        cursor: pointer;
    }
}
div#pasdecv{
    margin-top:15px;
    span {
        cursor: pointer;
    }
}
::placeholder {

  font-size: 14px;
}

div.panel_form {
    //box-shadow: 0 0 5px 5px rgba(0,0,0,0.1);
    /*@media (min-width:600px) {
        min-height:465px;
    }
    @media (max-width:600px) {
        min-height:450px;
    }*/
    border-radius: 20px;
    text-align: left;
    p{
        margin-bottom: 5px;
    }
    label {
        min-width:175px;
    }
    textarea {
        width: 100%;
        height:90px;
    }
}

.btn-lg, .btn-group-lg > .btn {
    padding: 0.5rem 1rem;
    font-size: 14px !important;
    line-height: 1.5;
    border-radius: 0.3rem;
}

.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
    color: #fff !important;
    background-color: #167bc1 !important;
    border-color: #167bc1 !important;
}

.btn-outline-primary {
    color: #167bc1 !important;
    border-color: #167bc1 !important;
    cursor: pointer;
}

.btn-outline-primary:hover {
    color: #fff !important;
    background-color: #45aef9 !important;
    border-color: #45aef9 !important;
}

div.panel_form_submit {
    box-shadow: 0 0 5px 5px rgba(0,0,0,0.1);
    border-radius: 20px;
    margin-top: 20px;
}
.title_form {
    margin-bottom: 25px;
}
form#nocv {
    input[type="text"] {
        width: 247px;
    }

    .title_form {
        font-size: 25px;
    }
}

span#bt_envoyer {
        border: none;
        display:inline-block;
        clear:both;
        background: #4ec34a;
        padding: 15px 29px;
        color: white;
        cursor:pointer;
        font-size: 18px;
        &:hover {
            background: #1e931a;
            color:white;
            font-size: 18px;
        }
    }

.error {
    border: 1px solid red;
}

input#nom {
    text-transform: uppercase;
}

input#prenom {
    text-transform: capitalize;
}

div#steps, div#psychometrie {
    text-align:center;
    margin-top: 50px;
}

div#steps div.row{
    margin-bottom:5px;
}
span.circle {
    background: #167bc1;
    border-radius: 50%;
    padding: 30px 40px;
    text-align: center;
    color: white;
    font-size: 30px;
}

.text-input label span {
    display: inline-block;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: bold;
}

.text-input input, .text-input textarea {
    padding: 11px 14px;
    min-height: 46px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 0;
    font-size: 16px;
    word-wrap: normal;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    resize: none;
}

.col-form-label, label{
    font-weight: bold;
    font-size: 17px;
}

/* styles de base si JS est activé */
.js .input-file-container {
  position: relative;
}
.js .input-file-trigger {
  display: inline-block;
  padding: 14px 45px;
  background: #c9d100;
  color: #fff;
  font-size: 22px;
  transition: all 0.4s;
  cursor: pointer;
}
.js .input-file {
  position: absolute;
  top: 0;
  left: 50%;
  width: 225px;
  margin-left: -112px;
  padding: 14px 0;
  opacity: 0;
  cursor: pointer;
}

#wrapper_form {
    margin-top: 17px;
}

/* quelques styles d'interactions */
.js .input-file:hover + .input-file-trigger,
.js .input-file:focus + .input-file-trigger,
.js .input-file-trigger:hover,
.js .input-file-trigger:focus {
  background: #34495e;
  color: #ffffff;
}

/* styles du retour visuel */
.file-return {
  margin: 5px 0;
}
.file-return:not(:empty) {
  margin: 5px 0;
}
.js .file-return {
  font-style: italic;
  font-size: 0.9em;
  font-weight: bold;
}
/* on complète l'information d'un contenu textuel
   uniquement lorsque le paragraphe n'est pas vide */
/*.js .file-return:not(:empty):before {
  content: "Selected file: "
  font-style: normal
  font-weight: normal
}*/

span#bt_placer_rdv {
    display: inline-block;
    padding: 14px 45px;
    background: #c9d100;
    color: #fff;
    font-size: 1em;
    transition: all 0.4s;
    cursor: pointer;
}
</style>
